import { useEffect, useState, useCallback } from 'react';
import { listDashboard } from '../services/catalogs';

const DEFAULT_REFRESH_MINUTES = 5;

export function useDashboard(params = {}, refreshMinutes = DEFAULT_REFRESH_MINUTES) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async (currentParams = params) => {
    try {
      setLoading(true);
      const response = await listDashboard(currentParams);
      setData(response);
      setError(null);
    } catch (err) {
      console.error('Error loading dashboard', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchDashboard(); // carga inicial o cuando cambian los params
  }, [fetchDashboard]);

  useEffect(() => {
    const interval = setInterval(
      () => fetchDashboard(params),
      refreshMinutes * 60 * 1000
    );

    return () => clearInterval(interval);
  }, [fetchDashboard, refreshMinutes]);

  return {
    data,
    loading,
    error,
    refresh: fetchDashboard, // recarga manual
  };
}
